export abstract class AbstractResponse {
  protected requiredFields: string[] = [];

  protected stringFields: string[] = [];
  protected numberFields: string[] = [];
  protected dateFields: string[] = [];
  protected booleanFields: string[] = [];

  protected constructor(data: any) {
    this.validateData(data);
  }

  protected validateData(data: any): void {
    this.requiredFields.forEach((field: string): void => {
      if (!data[field]) {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", "Missing required field: " + field);
      }
    });

    this.stringFields.forEach((field: string): void => {
      if (!data[field]) {
        return;
      }
      if (typeof data[field] !== "string") {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", `Field ${field} must be a string`);
      }
    });

    this.numberFields.forEach((field: string): void => {
      if (!data[field]) {
        return;
      }
      if (typeof data[field] !== "number") {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", `Field ${field} must be a number`);
      }
    });

    this.booleanFields.forEach((field: string): void => {
      if (!data[field]) {
        return;
      }
      if (typeof data[field] !== "boolean") {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", `Field ${field} must be a boolean`);
      }
    });

    this.dateFields.forEach((field: string): void => {
      if (!data[field]) {
        return;
      }
      if (typeof data[field] !== "string") {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", `Field ${field} must be a date string`);
      }
      if (isNaN(new Date(data[field]).getTime())) {
        throw new ErrInvalidAPIResponse(400, "errors.invalidAPIResponse", `Field ${field} must be a valid date string`);
      }
    });
  }
}

class ErrInvalidAPIResponse extends Error {
  statusCode: number;
  message: string;
  clientMessage: string;

  constructor(statusCode: number, clientMessage: string, message: string = "Invalid API Response") {
    super(message);
    this.statusCode = statusCode;
    this.message = message;
    this.clientMessage = clientMessage;
    this.name = "ErrInvalidAPIResponse";
  }
}